import { z } from 'zod';

/**
 * Response of `GET /depthtiles/meta` (spec 10) — the depth-tile dataset
 * edition currently served, so the client can stamp `?v=` on tile requests
 * (cache-busting) and flag downloaded regions whose depth pack predates it.
 */
export const depthTilesMeta = z.object({
  edition: z.string().min(1),
});
export type DepthTilesMeta = z.infer<typeof depthTilesMeta>;
